var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { Icon, Inset, Spacing, Stack, StackChildren, Text, } from '@doordash/design-language';
import ListCell from '@doordash/component-list-cell';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import { NonEmPlaceOrderStrings } from './PlaceOrderStrings';
import { Faqs } from './PlaceOrderPageData';
import { CollapsibleContainer } from './CollapsibleContainer';
import track from '../../utils/track';
import { PlaceOrderEvents } from '../../constants/events/names';
var strings = NonEmPlaceOrderStrings;
var FaqStepImg = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  height: ", ";\n"], ["\n  display: block;\n  height: ", ";\n"])), function (props) { return props.height + "px"; });
var FaqContainer = function () {
    var faqTitle = strings.faqs.title();
    var faqsData = Faqs;
    var onItemClicked = function (isOpen, faqId) {
        if (isOpen) {
            track(PlaceOrderEvents.FAQ_VIEW, {
                faq: faqId,
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { styles: Text.Styles.Title2, children: faqTitle }),
        faqsData.map(function (faqData, fIndex) { return (React.createElement(CollapsibleContainer, { key: "faq-" + fIndex, title: faqData.question, onItemClick: function (isOpen) { return onItemClicked(isOpen, faqData.id); } },
            React.createElement(Stack, { size: Stack.Sizes.XLarge }, faqData.steps.map(function (step, sIndex) { return (React.createElement(ListCell, { key: "step-" + sIndex, title: React.createElement(Text, { styles: Text.Styles.Body2 }, step.text), isSeparatorVisible: false, insetVerticalSize: ListCell.InsetSizes.XxxxSmall, columnGapSize: Spacing.XxSmall, renderBeforeContent: function () { return (React.createElement(Text, { styles: Text.Styles.Body2 }, sIndex + 1 + ".")); }, renderBelowContent: function () {
                    return !!step.img && (React.createElement(Inset, { horizontalSize: Inset.Sizes.None, verticalSize: Inset.Sizes.XxSmall },
                        React.createElement(FaqStepImg, { src: step.img.src, alt: "step-" + sIndex + "-img", height: step.img.height })));
                } })); })))); })));
};
// This is to provide a quick way for non-EM intent users
// to navigate away from the portal to the marketplace to place an order
export var NonEmPlaceOrder = function (_a) {
    var teamAccountId = _a.teamAccountId, onStartOrderClick = _a.onStartOrderClick;
    var startOrder = function () {
        track(PlaceOrderEvents.START_ORDER_CLICK, {
            team_account_id: teamAccountId,
        });
        onStartOrderClick();
    };
    React.useEffect(function () {
        track(PlaceOrderEvents.PAGE_VIEW, {
            team_account_id: teamAccountId,
            version: 2,
        });
    }, [teamAccountId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { size: Stack.Sizes.XxLarge },
            React.createElement(StackChildren, null,
                React.createElement(Text, { styles: Text.Styles.Body1, children: strings.description() }),
                React.createElement(Button, { onClick: startOrder, children: strings.cta.text(), trailingIcon: Icon.Types.ArrowUpRight, isInline: true }))),
        React.createElement(Inset, { horizontalSize: Inset.Sizes.None, verticalSize: Inset.Sizes.XLarge },
            React.createElement(FaqContainer, null))));
};
var templateObject_1;
